import { COLORS } from '../constants/theme';
import { formatPrice } from '../utils/priceFormatter';

export const drawSummary = (engine, { cartItems = [], groupsCount = 0 }) => {
    // Check space before summary
    engine.ensureSpace(80, { limit: 735, resetY: 36 });

    const doc = engine.getDoc();
    const cursor = engine.getCursor();

    let grandPairs = 0;
    let grandPrice = 0;
    cartItems.forEach(item => {
        grandPairs += item.unitQuantity;
        grandPrice += (item.unitQuantity * item.unitFinalPrice);
    });

    const summaryY = cursor.getY() + 20;

    // Top border line of summary section (matching screenshot)
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(1);
    doc.line(36, summaryY, 576, summaryY);

    // Row 1: Labels
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text("Total Pairs:", 36, summaryY + 16);
    doc.text("Styles:", 140, summaryY + 16);
    doc.text("Order Total", 576, summaryY + 16, { align: 'right' });

    // Row 2: Values
    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(11.5);
    doc.setTextColor(0, 0, 0);
    doc.text(String(grandPairs), 36, summaryY + 32);
    doc.text(String(groupsCount), 140, summaryY + 32);

    doc.setFont('Helvetica', 'bold');
    doc.setFontSize(12.5);
    doc.text(`$${formatPrice(grandPrice)}`, 576, summaryY + 32, { align: 'right' });

    const endY = summaryY + 40;
    cursor.setY(endY);
    return endY;
};
